import { LegalPage } from "../components/LegalPage";

const { Section } = LegalPage;

export default function Privacy() {
  return (
    <LegalPage title="Privacy Policy" updated="Giugno 2026">
      <p>
        La presente informativa descrive le modalità di trattamento dei dati personali degli utenti
        della piattaforma <strong>Agenda-ISF-COMO</strong> (di seguito "la Piattaforma"), ai sensi
        del Regolamento (UE) 2016/679 ("GDPR") e del D.Lgs. 196/2003 e successive modifiche.
      </p>

      <Section n="1" title="Titolare del trattamento">
        <p>
          Il Titolare del trattamento è il gestore della Piattaforma Agenda-ISF-COMO. Per qualsiasi
          richiesta relativa al trattamento dei dati è possibile scrivere all'indirizzo di contatto
          indicato nella sezione dedicata della Piattaforma.
        </p>
      </Section>

      <Section n="2" title="Tipologie di dati trattati">
        <p>Nell'ambito della registrazione e dell'utilizzo della Piattaforma vengono trattati:</p>
        <ul className="list-disc space-y-1 pl-6">
          <li>Dati anagrafici: nome, cognome;</li>
          <li>Dati di contatto: indirizzo email e numero di telefono;</li>
          <li>Dati professionali: ruolo (Medico o Informatore Scientifico), specializzazione o azienda farmaceutica;</li>
          <li>Dati di utilizzo: appuntamenti prenotati, disdette, scambi e preferenze di notifica;</li>
          <li>Credenziali di accesso (la password è conservata esclusivamente in forma cifrata).</li>
        </ul>
      </Section>

      <Section n="3" title="Finalità e base giuridica">
        <p>
          I dati sono trattati per: (a) consentire la registrazione e l'autenticazione; (b) gestire
          le agende e la prenotazione degli appuntamenti; (c) inviare notifiche transazionali via
          email e in-app; (d) adempiere a obblighi di legge. La base giuridica è l'esecuzione del
          servizio richiesto e il consenso espresso in fase di registrazione.
        </p>
      </Section>

      <Section n="4" title="Natura intermediaria della Piattaforma">
        <p>
          La Piattaforma agisce esclusivamente come <strong>intermediario tecnologico</strong> per
          la gestione delle agende e non interviene in alcun modo nella relazione professionale tra
          Medici e Informatori Scientifici del Farmaco.
        </p>
      </Section>

      <Section n="5" title="Modalità di trattamento e conservazione">
        <p>
          I dati sono trattati con strumenti informatici e misure di sicurezza adeguate. Le password
          sono protette mediante algoritmi di hashing. I dati sono conservati per il tempo necessario
          alle finalità indicate e per gli obblighi di legge.
        </p>
      </Section>

      <Section n="6" title="Comunicazione dei dati">
        <p>
          I dati necessari alla gestione degli appuntamenti (ad esempio nominativo e azienda
          dell'Informatore) sono resi visibili al Medico interessato e viceversa, al solo fine di
          consentire la gestione dell'agenda. Per l'invio delle email transazionali ci si avvale di
          fornitori di servizi di posta elettronica che agiscono come responsabili del trattamento.
        </p>
      </Section>

      <Section n="7" title="Diritti dell'interessato">
        <p>
          L'utente può in ogni momento esercitare i diritti di accesso, rettifica, cancellazione,
          limitazione, portabilità e opposizione, nonché revocare il consenso e proporre reclamo
          all'Autorità Garante per la protezione dei dati personali.
        </p>
      </Section>

      <Section n="8" title="Preferenze di notifica">
        <p>
          L'utente può attivare o disattivare in modo indipendente i canali di notifica (Email e
          In-App) dalla sezione "Preferenze notifiche" del proprio profilo.
        </p>
      </Section>
    </LegalPage>
  );
}
